import { Component, input, output } from '@angular/core';
import { FmntsButtonModule } from '@fmnts/components/button';
import { I18nModule } from '@fmnts/i18n';
import { SharedModule } from '../../../../../shared/shared.module';

@Component({
  selector: 'verify-self-checkout-error-modal',
  templateUrl: './self-checkout-modal-ui.component.html',
  standalone: true,
  imports: [FmntsButtonModule, I18nModule, SharedModule],
})
export class SelfCheckoutErrorModalUiComponent {
  title = input.required<string>();
  content = input.required<string>();
  onClose = output<string>();
}
